import {observer} from 'mobx-react';
import React from 'react';
import {PageHeading, PromiseMessage, PromiseRetry} from '../../../../lib/components';
import {X7PushableBlockLoader} from '../X7PushableBlockLoader';

@observer
export class X7PushableBlockLoaderState extends React.Component<{ loader: X7PushableBlockLoader }> {
  render() {
    const {loader} = this.props;
    const isPending = loader.state?.isPending === true;
    const isFailure = loader.state?.isRejected === true;

    if (isPending || isFailure)
      return (
        <>
          <PageHeading key="heading"> Pushable block </PageHeading>

          <PromiseMessage label="Loading pushable block" align="center"
                          state={loader.state}/>

          <PromiseRetry state={loader.state} retry={loader.load} align="center"/>
        </>);

    return null;
  }
}
